import { render, staticRenderFns } from "./FdmDashboard.vue?vue&type=template&id=6d90f6f3&scoped=true"
import script from "./FdmDashboard.vue?vue&type=script&lang=js"
export * from "./FdmDashboard.vue?vue&type=script&lang=js"
import style0 from "./FdmDashboard.vue?vue&type=style&index=0&id=6d90f6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d90f6f3",
  null
  
)

export default component.exports